"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _draftJs = require("draft-js");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class HistoryControls extends _react.Component {
  handleUndoClick() {
    const _this$props = this.props,
      editorState = _this$props.editorState,
      setEditorState = _this$props.setEditorState;
    if (!editorState.getUndoStack().isEmpty()) {
      setEditorState(_draftJs.EditorState.undo(editorState));
      this.props.focusEditor();
    }
  }
  handleRedoClick() {
    const _this$props2 = this.props,
      editorState = _this$props2.editorState,
      setEditorState = _this$props2.setEditorState;
    if (!editorState.getRedoStack().isEmpty()) {
      setEditorState(_draftJs.EditorState.redo(editorState));
      this.props.focusEditor();
    }
  }
  render() {
    const buttonClassName = this.props.buttonClassName;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "historyControls"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: buttonClassName,
      onClick: this.handleUndoClick.bind(this)
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-undo regular"
    })), /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: buttonClassName,
      onClick: this.handleRedoClick.bind(this)
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-repeat regular"
    })));
  }
}
exports.default = HistoryControls;